import { render, staticRenderFns } from "./WorkgateDialog.vue?vue&type=template&id=3bda7729&scoped=true"
import script from "./WorkgateDialog.vue?vue&type=script&lang=js"
export * from "./WorkgateDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkgateDialog.vue?vue&type=style&index=0&id=3bda7729&prod&scoped=true&lang=css"
import style1 from "./WorkgateDialog.vue?vue&type=style&index=1&id=3bda7729&prod&scoped=true&lang=css"
import style2 from "./WorkgateDialog.vue?vue&type=style&index=2&id=3bda7729&prod&scoped=true&lang=css"
import style3 from "@/assets/scss/pages/pages.scss?vue&type=style&index=3&prod&lang=scss&external"
import style4 from "@/assets/scss/pages/setting.scss?vue&type=style&index=4&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bda7729",
  null
  
)

export default component.exports